export default __webpack_public_path__ + "static/media/new_logo_dark.de478c33.svg";